// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"59221469","118":"ce0c64b8","239":"173632a3","459":"ed4f89d4","470":"9452bb83","488":"3efa476e","656":"58ff8697","791":"bac7171e","818":"3f044f82","849":"29eb06f6","935":"bd26378d"}[chunkId] + ".chunk.js";
};